import React from 'react'

const Twenty_five = () => {
    return (
        <div className='container'>
             <h1>Program to find the Largest number among n input Numbers</h1>
             <div className='containers'>
                 you have to take N input and find the greatest of them<br />
                 Example: <br />
                 Input :<br />
                 n=5;<br />
                 11 15 81 7 85<br />
                 Output:<br />
                 85<br />
             </div>
             <h3>How to  do it?</h3>
             <ol>
                 <li>we will take the multiple input by using loop</li>
                 <li>then will initialize first element as largest element</li>
                 <li>then we will the number with everyone if anyone is larger than number</li>
                 <li>then that number wil assign as largest number and step-3 will proceed again</li>
                 <li>if there is no larger number then curr largest number will our answer</li>
             </ol>
             <div className='containers'>
           <code className='library'>#include</code>   &lt;stdio.h &gt;<br/>

           <code className='keywords'>int </code>main()
&#123;<br/>
<code className='library'>printf</code>("\n\n\t\tStudytonight - Best place to learn\n\n\n");<br/>
<code className='keywords'>int</code> n,i;<br/>
<code className='keywords'>float</code> c,big;<br/>

<code className='library'> printf</code>("\n\nEnter the number of elements you wish to find the greatest element of: ");<br/>
<code className='library'> scanf</code>("%d", &n);<br/>
<code className='library'> printf</code>("\n\nEnter %d numbers :\n", n);<br/>

<code className='comment'> printf</code>("\n\n\t\t\tElement 1: ");<br/>

<code className='library'> //Important step- always initialize big to the first element</code>
<code className='library'> scanf</code>("%f", &big);<br/>

<code className='keywords'> for</code>(i = 2; i &lt;= n; i++)
    &#123;<br/>
    <code className='library'>     printf</code>("\n\t\t\tElement %d  : ", i);<br/>
    <code className='library'>     scanf</code>("%f", &c);<br/>
    <code className='comment'>  /* 
            if input number is larger than the 
            current largest number<br/>
        */</code>
            <code className='keywords'> if</code>(big &lt; c)  
            big = c;<br/> 
            <code className='comment'>//update big to the larger value</code><br/>
    &#125;<br/>

    <code className='library'>printf</code>("\n\n\nThe largest of the %d numbers is  %f ", n, big);<br/>
    <code className='library'> printf</code>("\n\n\n\n\t\t\tCoding is Fun !\n\n\n");<br/>
    <code className='library'> return</code> 0;<br/>
&#125;<br/>
             </div>
        </div>
    )
}

export default Twenty_five
